import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { Facility } from './../../../models/modules/facility';


@Injectable({ providedIn: 'root' })
export class FacilityService extends ApiServiceBase {
  FacilityAdded: EventEmitter<any> = new EventEmitter();
  FacilityUpdated: EventEmitter<any> = new EventEmitter();
    constructor(injector: Injector, private http: HttpClient) {
        super(injector);
        this.setBase(API_NAMES.stocks);
    }

    deactivateFacility(obj: any) {
        return this.client.put(this._url(`/deactivate`), obj);
    }

    getFacilityListing() {
        return this.http.get<Facility[]>(this._url());
    }

     getFacilityByID(id: number) {
        return this.http.get<Facility>(this._url(`/${id}`));
    }


    createFacility(model: any) {
        return this.client.post<string>(this._url(), model);
    }

        deactivateFacilityBatch(obj: any) {
      return this.client.put(this._url(`/batchDeactivate`), obj);
    }

    reactivateFacility(obj: any) {
      return this.client.put(this._url(`/reactivate`), obj);
    }
    reactivateFacilityBatch(obj: any) {
      return this.client.put(this._url(`/batchReactivate`), obj);
    }
    getfacilitydatagrid(paramsObj?: any, model?: any) {
        paramsObj = paramsObj || {};
        paramsObj.view = 'summary';
        let params = createHttpParams(paramsObj);

        return this.http
            .post<Facility[]>(this._url(`/grid-data`), model, {
                params,
                observe: 'response',
            })
            .pipe(map(augmentPaging));
    }

     updateFacility(id: number, model: any) {
        return this.client.put(this._url(`/${id}`), model);
    }
    private _url(v?: string | undefined) {
        v = v || '';
        return this.url(`/Facility${v}`);
    }

}
